export const AchievementType = {
  1: 'Session',
  2: 'Week',
  3: 'Program',
  4: 'Forum',
  5: 'Profile',
  6: 'WorkoutRating',
  7: 'PrepSession',
  8: 'Onboarding',
  9: 'Anniversary',
  10: 'Membership',
};

// Name -> id. `AchievementType` above is id -> name (it labels list rows and builds the
// select choices), so comparisons against a type value need this map instead.
export const AchievementTypeId = Object.entries(AchievementType).reduce(
  (acc, [id, name]) => ({ ...acc, [name]: Number(id) }),
  {},
);

export const TriggerType = {
  1: 'Coded',
  2: 'Times',
};

const buildChoices = (mapping) =>
  Object.entries(mapping).map(([value, name]) => ({
    id: Number(value),
    name,
  }));

export const typeChoices = buildChoices(AchievementType);
export const triggerTypeChoices = buildChoices(TriggerType);

export const PROTECTED_ACHIEVEMENT_NAMES = [
  'AP Member',
  'Training Logged',
  'Member',
  'Profile Completed',
  // Membership badges — granted from Praxis program/product ownership in code.
  'Trainer',
  'Apprentice',
  'All-In',
];

const recommendedTimesCopy = {
  [AchievementTypeId.Session]: 'Popular milestones: 1, 5, 10, 25, 50, 100, 200 sessions.',
  [AchievementTypeId.Week]: 'Popular milestones: 1, 2, 3, 5, 10, 20 weeks.',
  [AchievementTypeId.PrepSession]: 'Try 1, 5, 10 prep sessions to start.',
};

export const getRecommendedTimesCopy = (type) => recommendedTimesCopy[type] || null;

const protectedNamesLookup = new Set(
  PROTECTED_ACHIEVEMENT_NAMES.map((name) => name.trim().toLowerCase()),
);

export const isProtectedAchievementName = (name) =>
  Boolean(name) && protectedNamesLookup.has(name.trim().toLowerCase());
